export const SUBJECT_SELECTION_STATE = {
  selectedBoard: {},
  selectedSubject: {},
  selectedGrade: {},
  selectedProduct: {}
};
